var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCombinedShineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 39,
    viewBox: "0 0 293 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14812_28126)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.50634,
    cy: 131.814,
    rx: 3.50634,
    ry: 131.814,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 15.0098 23.9994)",
    fill: "url(#paint0_linear_14812_28126)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_14812_28126)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.19854,
    cy: 108.309,
    rx: 3.19854,
    ry: 108.309,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 39.0117 20.9994)",
    fill: "url(#paint1_linear_14812_28126)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.9121,
    y: 16.6888,
    width: 133.51,
    height: 1.69,
    fill: "url(#paint2_linear_14812_28126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14812_28126",
    x: 0.834823,
    y: 2.77403,
    width: 291.971,
    height: 35.3552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.08552,
    result: "effect1_foregroundBlur_14812_28126"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_14812_28126",
    x: 24.8368,
    y: 0.397079,
    width: 244.961,
    height: 34.7395,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.08552,
    result: "effect1_foregroundBlur_14812_28126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14812_28126",
    x1: 6.78412,
    y1: 263.405,
    x2: 6.56276,
    y2: 3.7393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14812_28126",
    x1: 6.18858,
    y1: 216.435,
    x2: 6.02475,
    y2: 3.07248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14812_28126",
    x1: 80.9121,
    y1: 17.5338,
    x2: 214.422,
    y2: 17.5338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShineIcon);
export default __webpack_public_path__ + "static/media/CombinedShineIcon.68e49bf3778d2bf1fd5440423181a111.svg";
export { ForwardRef as ReactComponent };